<template>
  <div class="page page-home">
    <div class="container">
      <search-bar></search-bar>

      <div class="films-title">精選電影</div>
      <div class="films-subtitle">
        每週更新各類啟智電影，給與追求智慧的人參與學術研究與分享
      </div>      

      <div class="films-list clearfix" v-if="wkFilms.length || films.length">
        <div class="films-slider">
          <el-carousel indicator-position="outside" height="852px" :interval="4000" trigger="click">
            <el-carousel-item v-for="v in wkFilms" :key="v.id">
              <router-link class="film-slide"
                :to="{ name: 'Film', params: { id: v.id } }" target="_blank"
                :style="$bgImg(v.cover)"       
              >
                <div class="film-mask"></div>
                <div class="film-content">
                  <div class="en-ttile">{{v.film_english_title}}</div>
                  <div class="cn-title">{{v.film_title}}</div>
                  <div class="desc">{{v.film_description || v.film_detail}}</div>
                </div>
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </div>

        <router-link class="film-item" v-for="(v, i) in films" :key="v.id"
          :to="{ name: 'Film', params: { id: v.id } }" target="_blank"
          :style="{ animationDelay: `${i % 10 * 140 + 140}ms` }"
          :class="{ left2: col3 ? (i > 1 && (i - 2) % 3 <= 1) : (i > 3 && i % 4 <= 1) }"
        >
          <div class="film-header" :style="$bgImg(v.cover)"></div>
          <div class="film-content">
            <div class="en-ttile">{{v.film_english_title}}</div>
            <div class="cn-title">{{v.film_title}}</div>
            <div class="desc">{{v.film_description || v.film_detail}}</div>
          </div>
        </router-link>
      </div>

      <div class="loading" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'
import SearchBar from '../components/SearchBar'

export default {
  name: 'Home',
  components: { SearchBar },
  data() {
    return {
      wkFilms: [],
      films: [],
      page: 1,
      loading: true,
      hasMore: true,
      col3: 4
    }
  },
  methods: {
     getWkFilms() {
      api.getFilms({ weekend: 1 }).then(data => {
        this.wkFilms = data
      })
    },
    getFilms(page = this.page) {
      this.loading = true
      api.getFilms({ weekend: 0, page }).then(data => {
        this.films = page == 1 ? data : this.films.concat(data)
        this.page = page
        this.loading = false
        this.hasMore = data.length > 9
      })
    },
     loadMore() {
      if (!this.loading && this.hasMore) {
        const top = document.documentElement.scrollTop || document.body.scrollTop
        const height = document.body.scrollHeight - document.body.clientHeight
        if (height - top < 350) {
          this.getFilms(this.page + 1)
        }
      }
    },
    setCol3() {
      const width = document.body.clientWidth
      this.col3 = width <= 1470
    }
  },
  created() {
    this.getWkFilms()
    this.getFilms()    

    window.addEventListener('scroll', this.loadMore)
    this.setCol3()
    window.addEventListener('resize', this.setCol3)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.loadMore)
    window.removeEventListener('resize', this.setCol3)
  }
}
</script>

<style lang="less" scoped>
.page-home {
  background-color: #e8e8e8;
  padding-top: 30px;
  padding-bottom: 80px;
}

.films-slider {
  width: 680px;
  height: 852px;
  float: left;
  margin-top: 90px;
  margin-left: 80px;  
  border-radius: 30px;
  box-shadow: 0 3px 18px 0 #bbb;
  animation: film 420ms linear forwards;

  &:hover {
    box-shadow: 0 3px 18px 0 #a5a5a5;
  }

  /deep/ .el-carousel__container {
    border-radius: 30px;
    overflow: hidden;
  }

  .film-slide {
    width: 680px;
    height: 852px;   
    display: block;
    transition: box-shadow 250ms;
    background: #eee no-repeat center center/ cover;    

    .film-mask {      
      position: absolute;
      left: 0;
      right: 0;
      top: 70%;
      bottom: 0;
      z-index: 1;
      background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,.5));
    }

    .film-content {
      position: absolute;
      left: 45px;
      right: 45px;
      bottom: 35px;
      z-index: 2;
      color: white;
    }

    .en-ttile {
      font-size: 18px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .cn-title {
      font-size: 28px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
    }

    .desc {
      font-size: 13px;
      margin-top: 20px;
      line-height: 20px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  /deep/ .el-carousel__indicator--horizontal {
    margin: 20px 14px;
    padding: 0;

    .el-carousel__button {
      background-color: rgba(197,191,188);
      opacity: 1;
      height: 15px;
      width: 15px;
      border-radius: 50%;
    }

    .el-carousel__button:hover {
      background-color: rgb(146, 146, 146);
    }

    &.is-active {
      .el-carousel__button, .el-carousel__button:hover {
        background-color: rgba(163,7,7);
      }
    }
  }
}

.film-item.left2 {
 margin-top: -78px;
}

</style>
